import { PureComponent } from 'react';
import styled from 'styled-components';
import { Map as ImmutableMap } from 'immutable';
import I18n from 'I18n';
import FormattedMessage from 'I18n/components/FormattedMessage';
import VizExButton from 'visitor-ui-component-library/button/VizExButton';
import getIn from 'transmute/getIn';
import { AGENT } from 'conversations-message-history/constants/messageUses';
import { FIRST, LAST } from 'conversations-message-history/constants/messagePositionDescriptors';
import { getHasQuickLinks, getQuickLinks } from 'conversations-message-history/common-message-format/operators/cmfQuickLinksGetters';
import { VISITOR } from 'conversations-message-history/common-message-format/constants/legacySenderTypes';

// @ts-expect-error untyped
import autolinker from 'autolinker';
import { getSenderType, getPlainText as getLegacyPlainText, getRichText as getLegacyRichText, getPlainText
// @ts-expect-error untyped
} from 'conversations-message-history/common-message-format/operators/commonMessageFormatGetters';
import { getRichText, getText
// @ts-expect-error untyped
} from 'conversations-message-history/initial-message/operators/initialMessageGetters';
import { getOptionValue, getOptionLabel
// @ts-expect-error untyped
} from 'conversations-message-history/quick-reply/operators/quickReplyGetters';
import { getQuickReply, getQuickReplyReplies, getQuickReplyAllowMultiSelect
// @ts-expect-error untyped
} from 'conversations-message-history/common-message-format/operators/cmfQuickReplyGetters';
// @ts-expect-error untyped
import { getSenderFromMessageSenders } from '../common-message/operators/getSenderFromMessageSenders';
import ContentText from '../atoms/ContentText';
import PrimaryMessage from '../primary-message/components/PrimaryMessage';
import PrimaryMessageContent from '../primary-message/components/PrimaryMessageContent';
import PrimaryMessageContentSection from '../primary-message/components/PrimaryMessageContentSection';
import PrimaryMessageFooter from '../primary-message/components/PrimaryMessageFooter';
import PrimaryMessageHeader from '../primary-message/components/PrimaryMessageHeader';
import QuickReplyGroup from '../quick-reply/QuickReplyGroup';
import { MAX_QUICK_REPLY_BUTTONS } from '../quick-reply/constants/quickReplies';
import QuickReplySelect from '../quick-reply/QuickReplySelect';
import QuickLinksGroup from '../quick-links/QuickLinksGroup';
import PlayMessageButton from '../common-message/PlayMessageButton';
import InitialMessageAvatar from './InitialMessageAvatar';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const AdjustedPrimaryMessageHeader = styled(PrimaryMessageHeader).withConfig({
  displayName: "InitialMessage__AdjustedPrimaryMessageHeader"
})(["margin:0px;height:0;"]);
class InitialMessage extends PureComponent {
  constructor(props) {
    super(props);
    this.handleQuickReplySend = () => {
      const {
        message,
        publishMessage
      } = this.props;
      const {
        selectedQuickReply
      } = this.state;
      const text = getOptionLabel(selectedQuickReply);
      const quickReply = getQuickReply(message);
      const updatedQuickReply = quickReply.set('quickReplies', [selectedQuickReply]);
      publishMessage === null || publishMessage === void 0 || publishMessage({
        text,
        quickReply: updatedQuickReply
      });
    };
    this.handleQuickReplySelect = ({
      target: {
        value
      }
    }) => {
      const {
        message
      } = this.props;
      const options = getQuickReplyReplies(message);
      const selected = options.filter(option => getOptionValue(option) === value).first();
      this.setState({
        selectedQuickReply: selected
      });
    };
    this.showQuickReplySelection = () => {
      const {
        message
      } = this.props;
      const quickReplies = getQuickReplyReplies(message);
      const allowMultiSelect = getQuickReplyAllowMultiSelect(message);
      return this.showQuickReplies() && quickReplies.count() > MAX_QUICK_REPLY_BUTTONS && !allowMultiSelect;
    };
    this.renderQuickReplySelect = () => {
      const {
        message,
        isThreadStarted,
        requiresExplicitConsentToProcess,
        requiresExplicitCookieConsent
      } = this.props;
      const {
        selectedQuickReply
      } = this.state;
      const quickReplies = getQuickReplyReplies(message);
      return /*#__PURE__*/_jsx("div", {
        className: "m-y-2",
        children: /*#__PURE__*/_jsx(QuickReplySelect, {
          quickReplyOptions: quickReplies,
          disabled: requiresExplicitConsentToProcess || requiresExplicitCookieConsent || !isThreadStarted,
          onChange: this.handleQuickReplySelect,
          value: getOptionValue(selectedQuickReply),
          placeholder: I18n.text('conversations-visitor-message-history.quickReply.selectionPlaceholder')
        })
      });
    };
    this.renderQuickReplySendButton = () => {
      const {
        isThreadStarted
      } = this.props;
      const {
        selectedQuickReply
      } = this.state;
      return /*#__PURE__*/_jsx(PrimaryMessageFooter, {
        children: /*#__PURE__*/_jsx(VizExButton, {
          disabled: !isThreadStarted || !getOptionValue(selectedQuickReply),
          onClick: this.handleQuickReplySend,
          size: "sm",
          use: "primary",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "conversations-visitor-message-history.quickReply.selectionComplete"
          })
        })
      });
    };
    this.state = {
      selectedQuickReply: ImmutableMap()
    };
  }
  get sender() {
    const {
      message,
      senders
    } = this.props;
    if (!senders) return undefined;
    return getSenderFromMessageSenders(message, senders);
  }
  hasQuickReplyOptions() {
    const {
      message
    } = this.props;
    const currentMessageSenderType = getSenderType(message);
    return getQuickReply(message) && currentMessageSenderType !== VISITOR;
  }
  hasQuickLinks() {
    const {
      message
    } = this.props;
    const currentMessageSenderType = getSenderType(message);
    return getHasQuickLinks(message) && currentMessageSenderType !== VISITOR;
  }
  showQuickReplies() {
    const {
      hasUnansweredQuickReplyMessage,
      positionDescriptors
    } = this.props;
    const hasNotBeenAnswered = hasUnansweredQuickReplyMessage && positionDescriptors.has(LAST);
    return this.hasQuickReplyOptions() && hasNotBeenAnswered;
  }
  showQuickLinks() {
    return this.hasQuickLinks();
  }
  renderAvatar() {
    const {
      chatHeadingConfig,
      sendFromResponders
    } = this.props;
    return /*#__PURE__*/_jsx(InitialMessageAvatar, {
      chatHeadingConfig: chatHeadingConfig,
      sender: this.sender,
      sendFromResponders: sendFromResponders
    });
  }
  renderQuickReplyGroup() {
    const {
      accentColor,
      isThreadStarted,
      message,
      publishMessage,
      requiresExplicitConsentToProcess,
      requiresExplicitCookieConsent
    } = this.props;
    const quickReplies = getQuickReplyReplies(message);
    const allowMultiSelect = getQuickReplyAllowMultiSelect(message);
    return /*#__PURE__*/_jsx(PrimaryMessageFooter, {
      children: /*#__PURE__*/_jsx(QuickReplyGroup, {
        disabled: requiresExplicitConsentToProcess || requiresExplicitCookieConsent || !isThreadStarted,
        options: quickReplies,
        message: message,
        multiSelect: allowMultiSelect,
        publishMessage: publishMessage,
        accentColor: accentColor
      })
    });
  }
  renderQuickLinksGroup() {
    const {
      onQuickLinkClick,
      message
    } = this.props;
    const quickLinks = getQuickLinks(message);
    return /*#__PURE__*/_jsx(PrimaryMessageFooter, {
      children: /*#__PURE__*/_jsx(QuickLinksGroup, {
        options: quickLinks,
        onQuickLinkClick: onQuickLinkClick
      })
    });
  }
  renderContentSection() {
    const getType = getIn(['metadata', '@type']);
    const {
      message
    } = this.props;
    let text;
    let richText;
    const isLegacyInitialMessage = Boolean(getType(message));
    if (isLegacyInitialMessage) {
      text = getLegacyPlainText(message);
      richText = getLegacyRichText(message);
    } else {
      text = getText(message);
      richText = getRichText(message);
    }
    const parsedRichText = autolinker.link(richText, {
      stripPrefix: false
    });
    return /*#__PURE__*/_jsxs(PrimaryMessageContentSection, {
      children: [/*#__PURE__*/_jsx(ContentText, {
        messageId: message.id,
        "aria-label": `${I18n.text('conversations-visitor-message-history.agentSays')} ${getPlainText(message)}`,
        contentText: parsedRichText || text,
        isPartialMessage: false
      }), this.showQuickReplySelection() && this.renderQuickReplySelect()]
    });
  }
  renderMessageFooter() {
    const {
      message
    } = this.props;
    const quickReplies = getQuickReplyReplies(message);
    const allowMultiSelect = getQuickReplyAllowMultiSelect(message);
    if (this.showQuickReplySelection()) {
      return this.renderQuickReplySendButton();
    }
    if (this.showQuickReplies() && (quickReplies.count() <= MAX_QUICK_REPLY_BUTTONS || allowMultiSelect)) {
      return this.renderQuickReplyGroup();
    }
    if (this.showQuickLinks()) {
      return this.renderQuickLinksGroup();
    }
    return null;
  }
  renderPlayMessageButton() {
    const {
      message,
      positionDescriptors,
      speechPocActive = false,
      audioPlaybackStatus = 'paused',
      messagesList
    } = this.props;
    return /*#__PURE__*/_jsx(PlayMessageButton, {
      message: message,
      positionDescriptors: positionDescriptors,
      speechPocActive: speechPocActive,
      audioPlaybackStatus: audioPlaybackStatus,
      messagesList: messagesList
    });
  }
  render() {
    const {
      positionDescriptors
    } = this.props;
    const isFirst = positionDescriptors.has(FIRST);
    return /*#__PURE__*/_jsxs(PrimaryMessage, {
      use: AGENT,
      children: [isFirst && /*#__PURE__*/_jsx(AdjustedPrimaryMessageHeader, {
        children: this.renderAvatar()
      }), /*#__PURE__*/_jsxs(PrimaryMessageContent, {
        shouldFocusMessage: Boolean(this.showQuickReplies()),
        children: [this.renderContentSection(), this.renderPlayMessageButton()]
      }), this.renderMessageFooter()]
    });
  }
}
InitialMessage.displayName = 'InitialMessage';
export default InitialMessage;